import React from 'react';
import { motion } from 'framer-motion';
import { Download, ShieldCheck, Star } from 'lucide-react';
import { trackAddToCart } from '../../hooks/useMetaPixel';
export function PricingSection() {
  const handleBuyClick = () => {
    // Track AddToCart event before redirecting
    trackAddToCart({
      content_name: 'Kit Dormí de Nuevo (40+)',
      content_ids: ['42964409974993'],
      content_type: 'product',
      value: 9300,
      currency: 'ARS'
    });
  };
  return <section id="pricing" className="py-24 px-4 sm:px-6 lg:px-8 bg-navy text-cream relative overflow-hidden" data-id="element-103">
      {/* Decorative background */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-104">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-purple opacity-20 blur-3xl" data-id="element-105"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-coral opacity-10 blur-3xl" data-id="element-106"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white text-navy rounded-3xl shadow-2xl overflow-hidden" data-id="element-108">
          <div className="bg-purple p-2 text-center text-white text-sm font-medium tracking-wide" data-id="element-109">
            OFERTA ESPECIAL DE LANZAMIENTO
          </div>

          <div className="p-8 sm:p-12 md:p-16 text-center" data-id="element-110">
            <h2 className="text-3xl sm:text-4xl font-bold mb-4 font-serif" data-id="element-111">
              Kit "Dormí de Nuevo (40+)"
            </h2>
            <p className="text-xl text-gray-600 mb-8" data-id="element-112">
              Protocolo Anti-Despertares 3AM (14 noches)
            </p>

            <div className="flex items-center justify-center mb-8" data-id="element-113">
              <div className="text-5xl sm:text-6xl font-bold text-navy" data-id="element-114">
                $9.300
              </div>
              <div className="ml-3 text-left" data-id="element-115">
                <div className="text-sm text-gray-500 line-through" data-id="element-116">
                  $18.600
                </div>
                <div className="text-sm font-medium text-green-600 uppercase" data-id="element-117">
                  50% OFF · Pago único
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-10 text-sm text-gray-600" data-id="element-118">
              <div className="flex items-center justify-center" data-id="element-119">
                <Download className="w-4 h-4 mr-2 text-purple" data-id="element-120" />
                Descarga inmediata PDF
              </div>
              <div className="flex items-center justify-center" data-id="element-121">
                <ShieldCheck className="w-4 h-4 mr-2 text-purple" data-id="element-122" />
                Pago 100% seguro
              </div>
            </div>

            <a href="https://argrutinas.com/cart/42964409974993:1" target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} className="inline-block w-full sm:w-auto px-10 py-5 bg-coral hover:bg-coral-hover text-navy text-xl font-bold rounded-full transition-all duration-300 shadow-lg hover:shadow-coral/30 transform hover:-translate-y-1 mb-6 text-center" data-id="element-123">
              Descargá el Kit Ahora
            </a>

            <p className="text-sm text-gray-500 mb-8" data-id="element-124">
              Garantía de satisfacción de 30 días. Si no te sirve, te devolvemos
              el dinero.
            </p>

            <div className="border-t border-gray-100 pt-8" data-id="element-125">
              <p className="text-lg font-serif italic text-gray-700" data-id="element-126">
                "Si hoy estás en esa etapa donde la noche te está comiendo la
                energía, no necesitás más tips. Necesitás un mapa."
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}